import { render, staticRenderFns } from "./Arrows.svg.vue?vue&type=template&id=46a44f0a"
import script from "./Arrows.svg.vue?vue&type=script&lang=ts"
export * from "./Arrows.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a44f0a')) {
      api.createRecord('46a44f0a', component.options)
    } else {
      api.reload('46a44f0a', component.options)
    }
    module.hot.accept("./Arrows.svg.vue?vue&type=template&id=46a44f0a", function () {
      api.rerender('46a44f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/Arrows.svg.vue"
export default component.exports